export default "__VITE_ASSET__B1TvzK0r__"